import { render, staticRenderFns } from "./MetricsScreen.vue?vue&type=template&id=c32843cc&"
import script from "./MetricsScreen.vue?vue&type=script&lang=ts&"
export * from "./MetricsScreen.vue?vue&type=script&lang=ts&"
import style0 from "./MetricsScreen.vue?vue&type=style&index=0&id=c32843cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports